import { GlobalState } from '../../actions';
import { ServerType } from '../../System/systemConfig';

export const selectorUseCaseLog = (state: GlobalState) => state.useCaseLogs;

export const selectorUseCaseLogEntities = (server: ServerType) => (state: GlobalState) =>
    selectorUseCaseLog(state)[server];
